import styled from "styled-components"
const playButton = require( "../images/video-display-overlay-images/play-button.svg" ) as string
const playButtonHover = require( "../images/video-display-overlay-images/play-button-hover.svg" ) as string

export const Container = styled.div`
  margin: 0 auto;
  max-width: 90%;

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 720px;
  }

  @media (min-width: 992px) {
    max-width: 960px;
  }

  @media (min-width: 1200px) {
    max-width: 1140px;
  }
`

export const VideoOverlay = styled.div`
  align-items: center;
  background-color: rgba(0,0,0,0.5);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;

  ::after {
    content: "";
    background-image: url(${ playButton });
    background-repeat: no-repeat;
    position: absolute;
    width: 20%;
    height: 20%;
    top: 42%;
    left: 45%;
  }

  :hover {
    cursor: pointer;
  }

  :hover::after {
    background-image: url(${ playButtonHover });
  }
`
